<template>
	<div class="search-bar">
		<uInput :placeholder="'请输入搜索条件'" class="m"></uInput>
		<uButton>搜索</uButton>
	</div>
</template>
<script>
	export default {
		name: 'searchBar'
	}
</script>
<style lang="scss" scoped>
	.search-bar {
		display: inline-block;
		height: 30px;
		.input-ctr { width: 200px; border-radius: 3px 0 0 3px; float: left; }
		.button { border-radius: 0 3px 3px 0; }
	}
</style>


// WEBPACK FOOTER //
// src/components/searchBar/searchBar.vue